function About() {
  return (
    <section className="section page-section about-page">
      <div className="about-page__number" aria-hidden="true">
        01
      </div>

      <div className="about-page__content">
        <p className="eyebrow">The Road Runner Mentality</p>
        <h1>THE ROAD IS EARNED.</h1>

        <p>
          Road Runner is a Cape Cod-based streetwear brand built around
          movement, ambition, and community. Inspired by basketball culture and
          rooted in Mashpee, the brand represents those who keep moving forward
          while never forgetting where they came from. Road Runner is more than
          clothing — it's about representing your roots, putting on for your
          community, and creating your own lane.
        </p>
        <br></br>
        <p>
          Born and raised in the Mashpee community on Cape Cod, Steven
          Gonsalves, founder of Road Runner, has built his name through genuine
          connections, community involvement, and a deep pride in his Wampanoag
          roots. Whether he's at a local gathering, on the basketball court, or
          with his dogs, Steven stays active, connected, and true to where he
          comes from. Road Runner is an extension of that same energy —
          community, culture, hustle, and authenticity.
        </p>
      </div>
    </section>
  );
}

export default About;
